import {Action} from "@ngrx/store";
import {Website} from '../../websites/website/website';

export const LOAD_WEBSITES: string = '[website] Load Websites';
export const LOAD_WEBSITES_SUCCESS: string = '[website] Load Websites Success';
export const LOAD_WEBSITES_FAIL: string = '[website] Load Websites Fail';

export const UPDATE_WEBSITE_DATA: string = '[website] Update Website Data';
export const UPDATE_WEBSITE_DATA_SUCCESS: string = '[website] Update Website Data Success';
export const UPDATE_WEBSITE_DATA_FAIL: string = '[website] Update Website Data Fail';

export const ADD_WEBSITE: string = '[website] Add Website';
export const UPDATE_WEBSITE_SCREEN_SHOT: string = '[website] Update Website Screen Shot';
export const UPDATE_WEBSITE_GOOGLE_SCORE: string = '[website] Update Website Google Score';
export const UPDATE_WEBSITE_SUB_DATA: string = '[website] Update Website Sub Data';
export const DEACTIVATE_WEBSITE: string = '[website] Deactivate Website';
export const REMOVE_WEBSITE: string = '[website] Remove Website';
export const CLEAR_WEBSITES: string = '[website] Clear Websites';

export const UPDATE_WEBSITE_WORDPRESS_VERSION: string = '[website] Update Website Wordpress Version';

export class LoadWebsites implements Action {

  readonly type: string = LOAD_WEBSITES;

}

export class LoadWebsitesSuccess implements Action {

  readonly type: string = LOAD_WEBSITES_SUCCESS;
  constructor(public payload: {
    [websiteId: number]: Website
  }) {}

}

export class LoadWebsitesFail implements Action {

  readonly type: string = LOAD_WEBSITES_FAIL;
  constructor(public payload: string) {}

}

export class AddWebsite implements Action {

  readonly type: string = ADD_WEBSITE;
  constructor(public payload: any) {}

}

export class UpdateWebsiteData implements Action {

  readonly type: string = UPDATE_WEBSITE_DATA;
  constructor(public payload: number) {}

}

export class UpdateWebsiteDataSuccess implements Action {

  readonly type: string = UPDATE_WEBSITE_DATA_SUCCESS;
  constructor(public payload: any) {}

}

export class UpdateWebsiteDataFail implements Action {

  readonly type: string = UPDATE_WEBSITE_DATA_FAIL;
  constructor(public payload: string) {}

}

export class UpdateWebsiteScreenShot implements Action {

  readonly type: string = UPDATE_WEBSITE_SCREEN_SHOT;
  constructor(public payload: {
    websiteId: number,
    screenshot: string
  }) {}

}
export class UpdateWebsiteGoogleScore implements Action {

  readonly type: string = UPDATE_WEBSITE_GOOGLE_SCORE;
  constructor(public payload: {
    websiteId: number,
    score: {}
  }) {}

}

export class UpdateWebsiteSubData implements Action {

  readonly type: string = UPDATE_WEBSITE_SUB_DATA;
  constructor(public payload: any) {}

}

export class DeactivateWebsite implements Action {

  readonly type: string = DEACTIVATE_WEBSITE;
  constructor(public payload: Website) {}

}

export class RemoveWebsite implements Action {

  readonly type: string = REMOVE_WEBSITE;
  constructor(public payload: number) {}

}

export class ClearWebsites implements Action {

  readonly type: string = CLEAR_WEBSITES;

}

export class UpdateWebsiteWordpressVersion implements Action {

  readonly type: string = UPDATE_WEBSITE_WORDPRESS_VERSION;
  constructor(public payload: {
    websiteId: number,
    wordpressVersion: string
  }) {}

}

export type WebsiteAction = LoadWebsites | LoadWebsitesSuccess | LoadWebsitesFail | UpdateWebsiteData | UpdateWebsiteDataSuccess | UpdateWebsiteDataFail | AddWebsite | UpdateWebsiteSubData | DeactivateWebsite | RemoveWebsite | ClearWebsites | UpdateWebsiteWordpressVersion;
